import AppShell from "../components/AppShell";
import TimeslotsSection from "./TimeslotsSection";

const Appointments = () => {
  return (
    <AppShell active="settings">
      <TimeslotsSection backTo="/settings" />
    </AppShell>
  );
};

export default Appointments;
